import React from "react";
import "./Quytrinh.css";

const steps = [
  {
    number: "1",
    title: "Liên hệ và báo yêu cầu",
    desc: "Bạn nhấc điện thoại gọi hotline hoặc nhắn tin qua Zalo.  ",
  },
  {
    number: "2",
    title: "Nhân viên thông báo phí",
    desc: "Sau khi tiếp nhận, nhân viên sẽ thông báo mức phí dịch vụ. ",
  },
  {
    number: "3",
    title: "Hoàn tất quy trình",
    desc: "Sau khi quẹt thẻ, bạn thanh toán khoản phí dịch vụ nhỏ nhân viên sẽ ck tức thì vào tk cá nhân. ",
  },
];

export default function Quytrinh() {
  return (
    <section className="bpc-section">
      <div className="bpc-container">
        <div className="bpc-card">
          <div className="bpc-header">
            <h2>Quy trình 3 bước tại nhà</h2>
          </div>

          <div className="bpc-content">
            <div className="bpc-steps-card">
              {steps.map((step) => (
                <div className="bpc-step-item" key={step.number}>
                  <div className="bpc-step-number">{step.number}</div>

                  <div className="bpc-step-content">
                    <h3>{step.title}</h3>
                    <p>{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="bpc-image-card">
              <div className="bpc-image-glow"></div>
              <img
                src="/1.webp"
                alt="rút thẻ tín dụng"
                className="bpc-image"
                width="460"
                height="480"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
